// Plain JSON backup of the household plan, so it can be restored in a later session.
import { plan as planStore, emptyPlan } from "@/lib/planStore";
import { warn } from "@/lib/log";

const SAVED_KEY = "ukready_plan_saved_at";
const KIND = "ukready-household-plan";

export const markSaved = () => { try { sessionStorage.setItem(SAVED_KEY, new Date().toISOString()); } catch (e) { warn("Could not record backup time", e); } window.dispatchEvent(new Event("ukready:plan-saved")); };
export const lastSaved = () => { try { return sessionStorage.getItem(SAVED_KEY); } catch (e) { warn("Could not read backup time", e); return null; } };

// Unsaved = the plan has real content and changed after the last download/print in this session.
export function hasUnsavedPlan() {
  const p = planStore.get();
  if (!p.onboarded && !p.household.postcode && !p.people.length) return false;
  const saved = lastSaved();
  return !saved || (p.updated && p.updated > saved);
}

export function downloadBackup() {
  const p = planStore.get();
  const body = JSON.stringify({ kind: KIND, version: 2, exported_at: new Date().toISOString(), plan: p }, null, 2);
  const url = URL.createObjectURL(new Blob([body], { type: "application/json" }));
  const a = Object.assign(document.createElement("a"), { href: url, download: `ukready-plan-${new Date().toISOString().slice(0, 10)}.json` });
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
  markSaved();
}

export function parseBackup(text) {
  let d;
  try { d = JSON.parse(text); } catch (e) { throw new Error("This isn't a UK Ready plan file (it couldn't be read)."); }
  if (d?.kind !== KIND || typeof d.plan !== "object" || !d.plan?.household) throw new Error("This file isn't a UK Ready household plan backup.");
  const base = emptyPlan();
  return { ...base, ...d.plan, household: { ...base.household, ...d.plan.household } };
}

export async function restoreBackup(file) {
  if (file.size > 2_000_000) throw new Error("That file is too large to be a plan backup.");
  const p = parseBackup(await file.text());
  planStore.save(p);
  markSaved();
  return p;
}
